import { Button } from "@/components/ui/button";
import { PricingCard } from "@/components/PricingCard";
import { Check } from "lucide-react";
import { PublicLayout } from "@/layouts/PublicLayout";

const plans = [
  {
    name: "Basic",
    description: "Perfect for getting started",
    price: "19.90",
    features: [
      "Até 50 transações por mês",
      "Relatórios básicos",
      "Suporte por email"
    ],
    popular: false
  },
  {
    name: "Pro",
    description: "Best for growing businesses",
    price: "49.90",
    features: [
      "Transações ilimitadas",
      "Relatórios avançados",
      "Exportação de dados",
      "Suporte prioritário",
      "Múltiplos usuários"
    ],
    popular: true
  },
  {
    name: "Enterprise",
    description: "For large organizations",
    price: "99.90",
    features: [
      "Todas as features do Pro",
      "API personalizada",
      "Integrações customizadas",
      "Gestor de conta dedicado",
      "SLA garantido"
    ],
    popular: false
  }
];

export default function PricingPage() {
  return (
    <PublicLayout>
      <div className="container mx-auto px-4 py-16">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold mb-4">Planos e Preços</h1>
          <p className="text-muted-foreground text-lg">
            Escolha o plano perfeito para suas necessidades
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {plans.map((plan) => (
            <PricingCard key={plan.name} {...plan} />
          ))}
        </div>

        <div className="mt-16 text-center">
          <h2 className="text-2xl font-semibold mb-8">Recursos inclusos em todos os planos</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto text-left">
            {[
              "Controle de despesas",
              "Controle de receitas",
              "Categorização",
              "Dashboard personalizado",
              "Exportação básica",
              "Suporte ao cliente"
            ].map((feature) => (
              <div key={feature} className="flex items-center gap-2">
                <Check className="h-5 w-5 text-green-500" />
                <span>{feature}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </PublicLayout>
  );
}
